import { createElementFromHTML } from '../../utilities/js/helper';
import AjaxLoad from '../../utilities/js/ajax-load';
import './article-teaser-list-press.scss';

class ArticleTeaserListPress {
    constructor (element, options) {
        // Defaults & Settings
        const defaults = {
            initAttr: 'data-articleteaserlistpress',
            tabAttr: 'data-articleteaserlistpress-tab',
            routeAttr: 'data-articleteaserlistpress-route',
            listValue: 'list'
        };

        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$$tabs = this.$root.querySelectorAll(`[${this.settings.tabAttr}]`);
        this.$list = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.listValue}"]`);
        this.$liveRegion = this.$root.querySelector('[aria-live]');

        // Properties
        this.route = this.$root.getAttribute(this.settings.routeAttr);
        this.hasYearsFilter = this.$list && this.route !== null;
    }

    initialize () {
        this.setEvents();
    }

    loadData(year) {
        const uri = `${this.route}?year=${year}`;

        new AjaxLoad(uri, {  
            onSuccess: (result) => {
                const $markup = createElementFromHTML(result);

                if ($markup) {
                    const contentUpdateEvent = new CustomEvent('content.update', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                        detail: {
                            $context: $markup
                        }
                    });

                    window.dispatchEvent(contentUpdateEvent);
                    this.$list.replaceChildren(...$markup.children);
                }
            }
        });
    }

    updateStates (activeIndex, activeYear) {
        this.$$tabs.forEach(($tab, index) => {
            $tab.setAttribute('aria-selected', activeIndex === index);
        });

        if (this.$liveRegion) {
            const text = this.$liveRegion.getAttribute(this.settings.initAttr);

            if (text !== null) {
                this.$liveRegion.textContent = text.replace('%year%', activeYear);
            }
        }
    }

    setEvents () {
        if (this.hasYearsFilter) {
            this.$$tabs.forEach(($tab, index) => {
                $tab.addEventListener('click', () => {
                    const year = $tab.getAttribute(this.settings.tabAttr);
                    this.updateStates(index, year);

                    if (year !== null) {
                        this.loadData(year);
                    }
                });
            });
        }
    }
}

export { ArticleTeaserListPress };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-articleteaserlistpress="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new ArticleTeaserListPress($root);
            $rootAPI.initialize();
        });
    }
});
